<template>
	<div class="main-loader" v-if='showLoader'>
		<div class="main-loader-content">
			<div class="loader"></div>
			<span>{{ message }}</span>
		</div>
	</div>
</template>

<script>
import bus from '@/bus/app-bus';

export default {
	name: 'MainLoader',
	data() {
		return {
			message: '',
			showLoader: false,
		};
	},
	mounted() {
		bus.$on('app-event-loader-toggle-view', ({ show, message }) => {
			this.showLoader = show;
			this.message = message;
		});
	},
};
</script>

<style lang='scss' scoped>
.main-loader {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 999;
	background-color: rgba(0, 0, 0, 0.45);
	display: flex;
	justify-content: center;
	align-items: center;
	.main-loader-content {
		color: #ffffff;
		font-size: 14px;
	}
}
.loader,
.loader:after {
	border-radius: 50%;
	width: 10em;
	height: 10em;
}
.loader {
	margin: 20px auto;
	font-size: 10px;
	position: relative;
	text-indent: -9999em;
	border-top: 1.1em solid rgba(255, 255, 255, 0.2);
	border-right: 1.1em solid rgba(255, 255, 255, 0.2);
	border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
	border-left: 1.1em solid #ffffff;
	-webkit-transform: translateZ(0);
	-ms-transform: translateZ(0);
	transform: translateZ(0);
	-webkit-animation: load8 1.1s infinite linear;
	animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
	0% {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes load8 {
	0% {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/MainLoader.vue